module.exports = __webpack_public_path__ + "static/media/LogoSocItalianaByN.8b715170.jpg";